import api from '../config/api';
import type { AgentProfile } from '../types';

export const agentService = {
  applyForAgent: async (data: {
    storeAddress: string; storePrimaryActivity: string;
    storeContactEmail: string; storeContactPhone: string;
    businessName?: string; website?: string;
  }) => {
    const res = await api.post('/agent/apply', data);
    return res.data;
  },

  getMyProfile: async (): Promise<{ success: boolean; data: AgentProfile }> => {
    const res = await api.get('/agent/profile');
    return res.data;
  },

  getSales: async (params?: { page?: number; limit?: number; startDate?: string; endDate?: string; raffleId?: string }) => {
    const res = await api.get('/agent/sales', { params });
    return res.data;
  },

  getDashboard: async (params?: { startDate?: string; endDate?: string }) => {
    const res = await api.get('/agent/dashboard', { params });
    return res.data;
  },

  getTicketImageUrl: (ticketId: string) => `${api.defaults.baseURL}/agent/tickets/${ticketId}/image`,

  // Admin
  adminGetAgents: async (params?: { page?: number; limit?: number; status?: string }) => {
    const res = await api.get('/admin/agents', { params });
    return res.data;
  },

  adminGetAgent: async (id: string): Promise<{ success: boolean; data: AgentProfile }> => {
    const res = await api.get(`/admin/agents/${id}`);
    return res.data;
  },

  adminApproveAgent: async (id: string) => {
    const res = await api.post(`/admin/agents/${id}/approve`);
    return res.data;
  },

  adminDisableAgent: async (id: string, comment?: string) => {
    const res = await api.post(`/admin/agents/${id}/disable`, { comment });
    return res.data;
  },

  adminRejectAgent: async (id: string, reason: string) => {
    const res = await api.post(`/admin/agents/${id}/reject`, { reason });
    return res.data;
  },

  adminEnableAgent: async (id: string) => {
    const res = await api.post(`/admin/agents/${id}/enable`);
    return res.data;
  },

  adminAddComment: async (id: string, comment: string) => {
    const res = await api.post(`/admin/agents/${id}/comment`, { comment });
    return res.data;
  },

  adminGetComments: async (id: string, params?: { page?: number; limit?: number }) => {
    const res = await api.get(`/admin/agents/${id}/comments`, { params });
    return res.data;
  },

  adminGetMetrics: async (id: string, params?: { startDate?: string; endDate?: string }) => {
    const res = await api.get(`/admin/agents/${id}/metrics`, { params });
    return res.data;
  },

  adminGetSales: async (id: string, params?: { page?: number; limit?: number; startDate?: string; endDate?: string }) => {
    const res = await api.get(`/admin/agents/${id}/sales`, { params });
    return res.data;
  },

  adminToggleLargeWin: async (id: string, enabled: boolean) => {
    const res = await api.post(`/admin/agents/${id}/large-win-capability`, { enabled });
    return res.data;
  },

  adminUpdateAgent: async (id: string, data: {
    storeAddress?: string; storePrimaryActivity?: string;
    storeContactEmail?: string; storeContactPhone?: string;
    businessName?: string; website?: string;
  }) => {
    const res = await api.put(`/admin/agents/${id}`, data);
    return res.data;
  },
};
